// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2I3K_","col":"styles_col__1qF41"};